const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ===============================================================
   LensesPK - 2-pair deal cart cleanup

   The deal can add a hidden Rs 0 line item per chosen shade so
   the shade names print on the PostEx courier label (PostEx only
   sends product title + SKU and ignores line item properties).
   Current orders use a single combo product instead, so this only
   still matters for older carts and the fallback path.

   Those lines are plumbing, not products. This runs on EVERY page
   so it covers the cart page, the cart drawer and the header:

     1. HIDE   - hides every azadi-pair-* row wherever it renders
     2. COUNT  - header bubble ignores the hidden lines (1 deal = 1)
     3. SYNC   - hidden shade quantities follow the deal line, and
                 are removed when the deal leaves the cart
     4. GUARD  - blocks checkout if a deal reaches the cart with no
                 Pair 1 / Pair 2 selected

   Safety rule: shade lines are only zeroed when NO deal line is
   left in the cart. While a deal exists an unmatched shade line is
   left alone, so a naming mismatch can never silently strip the
   shade names off the courier label.

   NOTE: the handles below (azadi-pair-*, azadi-sale-2026-any-2-pairs)
   are the ORIGINAL product handles. They still identify the same
   products even though the titles now read FLASH SALE, so they must
   not be renamed here unless the products themselves are renamed.
   =============================================================== */
(function () {
  var SHADE = 'azadi-pair-';
  var DEAL = 'azadi-sale-2026-any-2-pairs';
  var PICKER = '/pages/flash-sale';
  var ROW = 'tr, li, .cart-item, .cart-drawer-item';
  var CHECKOUT =
    '[name="checkout"], #checkout, .cart__checkout-button, .cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button';
  var GUARD_KEY = 'azadiSyncRuns';

  var blocked = false;
  var busy = false;

  function present() {
    return !!document.querySelector('a[href*="/products/' + SHADE + '"]');
  }
  function onCartPage() {
    return location.pathname.indexOf('/cart') === 0;
  }

  function slug(s) {
    return String(s == null ? '' : s).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function hasPairs(props) {
    if (!props) return false;
    var keys = Object.keys(props);
    for (var i = 0; i < keys.length; i++) {
      if (/^pair/i.test(keys[i]) && String(props[keys[i]] || '').trim()) return true;
    }
    return false;
  }

  /* ---- styles ---- */

  function injectCss() {
    if (document.getElementById('azadi-cart-css')) return;
    var css = document.createElement('style');
    css.id = 'azadi-cart-css';
    css.textContent =
      'tr.azadi-hidden,li.azadi-hidden,.azadi-hidden.cart-item,.azadi-hidden.cart-drawer-item{display:none !important}' +
      '.azadi-guard{display:flex;flex-wrap:wrap;align-items:center;gap:14px;margin:0 0 20px;padding:16px 18px;' +
      'border:1px solid rgba(245,197,66,.55);border-radius:14px;background:rgba(245,197,66,.10);font-size:14px;line-height:1.5}' +
      '.azadi-guard b{display:block;font-weight:800;margin-bottom:2px}' +
      '.azadi-guard p{margin:0;flex:1 1 220px;opacity:.85}' +
      '.azadi-guard a{flex:0 0 auto;text-decoration:none;background:linear-gradient(100deg,#F5C542,#FFD469 45%,#F5C542);' +
      'color:#1A1200;border-radius:10px;padding:12px 20px;font-size:12.5px;font-weight:900;letter-spacing:.07em}' +
      '.azadi-blocked{opacity:.4 !important;pointer-events:none !important}' +
      /* cart drawer: stop long product names colliding with the line price */
      '.cart-drawer .cart-item{grid-template-columns:auto minmax(0,1fr) auto !important}' +
      '.cart-drawer .cart-item__media{grid-row:1 / 3 !important;grid-column:1 !important}' +
      '.cart-drawer .cart-item__details{grid-column:2 !important;min-width:0 !important}' +
      '.cart-drawer .cart-item__totals{grid-column:3 !important;align-items:flex-start !important;white-space:nowrap}' +
      '.cart-drawer .cart-items .cart-item__quantity{grid-column:2 / 4 !important}' +
      '.cart-drawer .cart-item__name{display:block;overflow-wrap:anywhere;line-height:1.35}' +
      '.cart-drawer .cart-item__details .cart-item__price-wrapper{display:none !important}' +
      '@media screen and (max-width:749px){.cart-drawer .cart-item__name{font-size:15px}}';
    (document.head || document.documentElement).appendChild(css);
  }

  /* ---- 1. hide ---- */

  function hide() {
    var links = document.querySelectorAll('a[href*="/products/' + SHADE + '"]');
    for (var i = 0; i < links.length; i++) {
      var row = links[i].closest ? links[i].closest(ROW) : null;
      if (row) row.classList.add('azadi-hidden');
    }
  }

  /* ---- 2. header bubble count ---- */

  function paintCount(n) {
    var nodes = document.querySelectorAll('.cart-count-bubble span, .cart-count-bubble');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.classList.contains('visually-hidden')) continue;
      if (el.children.length) continue;
      var next = String(n);
      if (el.textContent.trim() !== next) el.textContent = next;
    }
  }

  /* ---- 4. checkout guard ---- */

  function paintGuard(on) {
    blocked = on;

    var btns = document.querySelectorAll(CHECKOUT);
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('azadi-blocked', on);
      if ('disabled' in btns[i]) btns[i].disabled = on;
    }

    var box = document.getElementById('azadiGuard');

    if (!on) {
      if (box && box.parentNode) box.parentNode.removeChild(box);
      return;
    }
    if (box) return;

    box = document.createElement('div');
    box.className = 'azadi-guard';
    box.id = 'azadiGuard';
    box.innerHTML =
      '<p><b>Please pick your 2 shades</b>' +
      'Your Flash Sale deal is in the cart without any shades selected. ' +
      'Choose your 2 shades so we send the right lenses.</p>' +
      '<a href="' + PICKER + '">PICK MY 2 SHADES</a>';

    var anchor =
      document.querySelector('.cart-drawer__footer') ||
      document.querySelector('.drawer__footer') ||
      document.querySelector('.cart__footer') ||
      document.querySelector('#main-cart-footer') ||
      document.querySelector('cart-items') ||
      document.querySelector('#main-cart-items');

    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
  }

  document.addEventListener('click', function (e) {
    if (!blocked) return;
    var hit = e.target.closest ? e.target.closest(CHECKOUT) : null;
    if (!hit) return;
    e.preventDefault();
    e.stopPropagation();
    var box = document.getElementById('azadiGuard');
    if (box && box.scrollIntoView) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  /* ---- 3. quantity sync ---- */

  function runs() {
    try { return parseInt(sessionStorage.getItem(GUARD_KEY) || '0', 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpRuns() { try { sessionStorage.setItem(GUARD_KEY, String(runs() + 1)); } catch (e) {} }
  function clearRuns() { try { sessionStorage.removeItem(GUARD_KEY); } catch (e) {} }

  function refresh() {
    if (busy) return;
    if (!present() && !onCartPage()) return;
    busy = true;

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];

        var want = {};
        var hasDeal = false;
        var naked = false;
        var hiddenQty = 0;
        var shadeLines = [];

        items.forEach(function (it) {
          var handle = it.handle || '';
          if (handle === DEAL) {
            hasDeal = true;
            var props = it.properties || {};
            if (!hasPairs(props)) { naked = true; return; }
            Object.keys(props).forEach(function (k) {
              if (!/^pair/i.test(k)) return;
              var h = SHADE + slug(props[k]);
              want[h] = (want[h] || 0) + (it.quantity || 0);
            });
          } else if (handle.indexOf(SHADE) === 0) {
            shadeLines.push(it);
            hiddenQty += it.quantity || 0;
          }
        });

        if (hiddenQty) paintCount(Math.max(0, (cart.item_count || 0) - hiddenQty));
        paintGuard(naked);

        if (!shadeLines.length) { clearRuns(); busy = false; return; }

        var changes = [];
        shadeLines.forEach(function (it) {
          if (!hasDeal) {
            if (it.quantity !== 0) changes.push({ id: it.key, quantity: 0 });
            return;
          }
          var target = want[it.handle];
          if (typeof target !== 'number') return;   // unmatched: leave it alone
          if (it.quantity !== target) changes.push({ id: it.key, quantity: target });
        });

        if (!changes.length || runs() >= 4) {
          if (!changes.length) clearRuns();
          busy = false;
          return;
        }

        bumpRuns();

        var chain = Promise.resolve();
        changes.forEach(function (c) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(c)
            });
          });
        });

        return chain.then(function () { window.location.reload(); });
      })
      .catch(function (err) { busy = false; if (window.console) console.error('[Deal cart]', err); });
  }

  /* ---- boot ---- */

  function boot() {
    injectCss();
    hide();
    refresh();

    if (!window.MutationObserver) return;

    var hidePending = false;
    var timer = null;

    new MutationObserver(function () {
      if (!hidePending) {
        hidePending = true;
        requestAnimationFrame(function () { hidePending = false; hide(); });
      }
      if (timer) clearTimeout(timer);
      timer = setTimeout(refresh, 500);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
